import { fetchCurrentUser } from '../../ducks/user.duck';
import { onCheckUserStripeAccountLinked, onGetModeratorCreateAndUpdateCollection, onGetModeratorFindCollection, onCheckUserAlreadyExistApi, syncCircleSpacesMemberCountsApi, syncUserToCircleApi } from '../../util/api';
import { parse } from '../../util/urlHelpers';
import { fetchSpaceList } from '../AdminPanelSupabasePage/AdminPanelSupabasePage.duck';

// ================ Action types ================ //

export const FETCH_MODERATORS_REQUEST = 'app/AdminPanelModeratorsPage/FETCH_MODERATORS_REQUEST';
export const FETCH_MODERATORS_SUCCESS = 'app/AdminPanelModeratorsPage/FETCH_MODERATORS_SUCCESS';
export const FETCH_MODERATORS_ERROR = 'app/AdminPanelModeratorsPage/FETCH_MODERATORS_ERROR';

export const FETCH_ADMIN_MODERATOR_REQUEST = 'app/AdminPanelModeratorsPage/FETCH_ADMIN_MODERATOR_REQUEST';
export const FETCH_ADMIN_MODERATOR_SUCCESS = 'app/AdminPanelModeratorsPage/FETCH_ADMIN_MODERATOR_SUCCESS';
export const FETCH_ADMIN_MODERATOR_ERROR = 'app/AdminPanelModeratorsPage/FETCH_ADMIN_MODERATOR_ERROR';

export const ADD_UPDATE_MODERATORS_REQUEST = 'app/AdminPanelModeratorsPage/ADD_UPDATE_MODERATORS_REQUEST';
export const ADD_UPDATE_MODERATORS_SUCCESS = 'app/AdminPanelModeratorsPage/ADD_UPDATE_MODERATORS_SUCCESS';
export const ADD_UPDATE_MODERATORS_ERROR = 'app/AdminPanelModeratorsPage/ADD_UPDATE_MODERATORS_ERROR';

export const SYNC_USER_REQUEST = 'app/AdminPanelModeratorsPage/SYNC_USER_REQUEST';
export const SYNC_USER_SUCCESS = 'app/AdminPanelModeratorsPage/SYNC_USER_SUCCESS';
export const SYNC_USER_ERROR = 'app/AdminPanelModeratorsPage/SYNC_USER_ERROR';
export const SYNC_USER_CLEAR = 'app/AdminPanelModeratorsPage/SYNC_USER_CLEAR';

export const SYNC_CIRCLE_SPACES_REQUEST = 'app/AdminPanelModeratorsPage/SYNC_CIRCLE_SPACES_REQUEST';
export const SYNC_CIRCLE_SPACES_SUCCESS = 'app/AdminPanelModeratorsPage/SYNC_CIRCLE_SPACES_SUCCESS';
export const SYNC_CIRCLE_SPACES_ERROR = 'app/AdminPanelModeratorsPage/SYNC_CIRCLE_SPACES_ERROR';
export const SYNC_CIRCLE_SPACES_CLEAR = 'app/AdminPanelModeratorsPage/SYNC_CIRCLE_SPACES_CLEAR';

export const TOTAL_GROUPS_PER_PAGE = 10;
export const PER_PAGE_MODERATORS = 10;

// ================ Reducer ================ //

const initialState = {
  fetchModeratorsInProgress: false,
  fetchModeratorsError: null,
  moderators: [],
  moderatorParams: null,

  addUpdateModeratorsInProgressType: null,
  addUpdateModeratorsInProgressId: null,
  addUpdateModeratorsInError: null,

  fetchAdminModeratorInProgress: false,
  fetchAdminModeratorError: null,
  adminModerator: null,

  syncUserInProgress: false,
  syncUserError: null,
  syncUserSuccess: null,

  syncCircleSpacesInProgress: false,
  syncCircleSpacesError: null,
  syncCircleSpacesSuccess: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {

    case FETCH_MODERATORS_REQUEST:
      return { ...state, fetchModeratorsInProgress: true, fetchModeratorsError: null };
    case FETCH_MODERATORS_SUCCESS:
      return {
        ...state,
        fetchModeratorsInProgress: false,
        moderators: payload.data,
        moderatorParams: payload.pagination,
        addUpdateModeratorsInProgressType: null,
        addUpdateModeratorsInProgressId: null,
        addUpdateModeratorsInError: null
      };
    case FETCH_MODERATORS_ERROR:
      return { ...state, fetchModeratorsInProgress: false, fetchModeratorsError: payload };

    case FETCH_ADMIN_MODERATOR_REQUEST:
      return {
        ...state,
        fetchAdminModeratorInProgress: true,
        fetchAdminModeratorError: null,
        adminModerator: null
      };
    case FETCH_ADMIN_MODERATOR_SUCCESS:
      return {
        ...state,
        fetchAdminModeratorInProgress: false,
        fetchAdminModeratorError: null,
        adminModerator: payload
      };
    case FETCH_ADMIN_MODERATOR_ERROR:
      return {
        ...state,
        fetchAdminModeratorInProgress: false,
        fetchAdminModeratorError: null,
        adminModerator: null
      };

    case ADD_UPDATE_MODERATORS_REQUEST:
      return {
        ...state,
        addUpdateModeratorsInProgressType: payload.type,
        addUpdateModeratorsInProgressId: payload.id,
        addUpdateModeratorsInError: null
      };
    case ADD_UPDATE_MODERATORS_SUCCESS:
      return {
        ...state,
        addUpdateModeratorsInProgressType: null,
        addUpdateModeratorsInProgressId: null,
        addUpdateModeratorsInError: null
      };
    case ADD_UPDATE_MODERATORS_ERROR:
      return {
        ...state,
        addUpdateModeratorsInProgressType: null,
        addUpdateModeratorsInProgressId: null,
        addUpdateModeratorsInError: payload
      };

    case SYNC_USER_REQUEST:
      return {
        ...state,
        syncUserInProgress: true,
        syncUserError: null,
        syncUserSuccess: null
      };
    case SYNC_USER_SUCCESS:
      return {
        ...state,
        syncUserInProgress: false,
        syncUserError: null,
        syncUserSuccess: payload?.exists ? 'exists' : 'created'
      };
    case SYNC_USER_ERROR:
      return {
        ...state,
        syncUserInProgress: false,
        syncUserError: payload,
        syncUserSuccess: null
      };

    case SYNC_USER_CLEAR:
      return {
        ...state,
        syncUserError: null,
        syncUserSuccess: null
      };

    case SYNC_CIRCLE_SPACES_REQUEST:
      return {
        ...state,
        syncCircleSpacesInProgress: true,
        syncCircleSpacesError: null,
        syncCircleSpacesSuccess: null
      };
    case SYNC_CIRCLE_SPACES_SUCCESS:
      return {
        ...state,
        syncCircleSpacesInProgress: false,
        syncCircleSpacesError: null,
        syncCircleSpacesSuccess: payload
      };
    case SYNC_CIRCLE_SPACES_ERROR:
      return {
        ...state,
        syncCircleSpacesInProgress: false,
        syncCircleSpacesError: payload,
        syncCircleSpacesSuccess: null
      };
    case SYNC_CIRCLE_SPACES_CLEAR:
      return {
        ...state,
        syncCircleSpacesError: null,
        syncCircleSpacesSuccess: null
      };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const fetchModeratorsRequest = () => ({ type: FETCH_MODERATORS_REQUEST });
export const fetchModeratorsSuccess = moderators => ({
  type: FETCH_MODERATORS_SUCCESS,
  payload: moderators,
});
export const fetchModeratorsError = error => ({
  type: FETCH_MODERATORS_ERROR,
  payload: error,
});

export const fetchAdminModeratorRequest = () => ({ type: FETCH_ADMIN_MODERATOR_REQUEST });
export const fetchAdminModeratorSuccess = moderators => ({
  type: FETCH_ADMIN_MODERATOR_SUCCESS,
  payload: moderators,
});
export const fetchAdminModeratorError = error => ({
  type: FETCH_ADMIN_MODERATOR_ERROR,
  payload: error,
});

export const addUpdateModeratorsRequest = (params) => ({ type: ADD_UPDATE_MODERATORS_REQUEST, payload: params });
export const addUpdateModeratorsSuccess = () => ({
  type: ADD_UPDATE_MODERATORS_SUCCESS,
});
export const addUpdateModeratorsError = error => ({
  type: ADD_UPDATE_MODERATORS_ERROR,
  payload: error,
});

export const syncUserRequest = () => ({ type: SYNC_USER_REQUEST });
export const syncUserSuccess = (data) => ({
  type: SYNC_USER_SUCCESS,
  payload: data,
});
export const syncUserError = error => ({
  type: SYNC_USER_ERROR,
  payload: error,
});
export const syncUserClear = () => ({ type: SYNC_USER_CLEAR });

export const syncCircleSpacesRequest = () => ({ type: SYNC_CIRCLE_SPACES_REQUEST });
export const syncCircleSpacesSuccess = data => ({
  type: SYNC_CIRCLE_SPACES_SUCCESS,
  payload: data,
});
export const syncCircleSpacesError = error => ({
  type: SYNC_CIRCLE_SPACES_ERROR,
  payload: error,
});
export const syncCircleSpacesClear = () => ({ type: SYNC_CIRCLE_SPACES_CLEAR });

// ================ Thunks ================ //

export const fetchModerators = (params) => (dispatch, getState, sdk) => {
  dispatch(fetchModeratorsRequest());
  // Add your API call here to fetch moderators
  return onGetModeratorFindCollection(params)
    .then(response => {
      dispatch(fetchModeratorsSuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(fetchModeratorsError(e.message));
      return e.message;
    });
};

export const fetchAdminModerator = (params) => (dispatch, getState, sdk) => {
  dispatch(fetchAdminModeratorRequest());
  // Add your API call here to fetch moderators
  return onGetModeratorFindCollection(params)
    .then(async response => {
      const adminData = response.data.filter((st) => st.status == "active" && st.role == "admin");
      const { userId } = adminData.length == 1 ? adminData[0] : {};
      const { isAuthorStripeAccountLinked = false } = userId ? await onCheckUserStripeAccountLinked({ userId: userId }) : {};
      dispatch(fetchAdminModeratorSuccess(adminData.length == 1 ? { ...adminData[0], isAuthorStripeAccountLinked } : null));
      return response;
    })
    .catch(e => {
      dispatch(fetchAdminModeratorError(e.message));
      return e.message;
    });
};

export const createUpdateModerators = (params, fetchParams) => (dispatch, getState, sdk) => {
  const {
    type,
    id,
    ...rest
  } = params;

  dispatch(addUpdateModeratorsRequest({
    type,
    id
  }));

  // Import the badge removal API
  const { onModeratorRemoveFromGroup } = require('../../util/api');

  // Add your API call here to fetch moderators
  return onGetModeratorCreateAndUpdateCollection({ ...rest })
    .then(async response => {
      // If status is 'delete', also call the badge removal API
      if (rest.status === 'delete' && rest.moderatorId && rest.groupId) {
        try {
          const badgeResult = await onModeratorRemoveFromGroup({
            userId: rest.moderatorId,
            groupId: rest.groupId
          });
          console.log('[createUpdateModerators] Badge removal result:', badgeResult);
        } catch (badgeError) {
          console.error('[createUpdateModerators] Badge removal failed:', badgeError);
          // Continue even if badge removal fails
        }
      }

      dispatch(addUpdateModeratorsSuccess(response));
      dispatch(fetchModerators(fetchParams));
      return response;
    })
    .catch(e => {
      console.log(e.message, '&&& &&& => e');
      dispatch(addUpdateModeratorsError(e.message));
      return e.message
    });
};

export const syncUser = (email) => (dispatch, getState, sdk) => {
  dispatch(syncUserRequest());

  // First check if user exists in Sharetribe
  return onCheckUserAlreadyExistApi({ email })
    .then(response => {
      const user = response?.user;

      if (!user) {
        throw new Error('User not found in Sharetribe with this email address');
      }

      // User exists in Sharetribe, now sync to Circle
      return syncUserToCircleApi({ email });
    })
    .then(circleResponse => {
      if (circleResponse.success) {
        dispatch(syncUserSuccess({ exists: circleResponse.exists }));
        // Clear success message after 2 seconds
        setTimeout(() => {
          dispatch(syncUserClear());
        }, 2000);
        return circleResponse;
      } else {
        throw new Error(circleResponse.message || 'Failed to sync user to Circle');
      }
    })
    .catch(e => {
      const errorMessage = e.message || 'Failed to sync user';
      dispatch(syncUserError(errorMessage));
      // Clear error message after 2 seconds
      setTimeout(() => {
        dispatch(syncUserClear());
      }, 2000);
      throw e;
    });
};

export const syncCircleSpacesMemberCounts = () => dispatch => {
  dispatch(syncCircleSpacesRequest());

  return syncCircleSpacesMemberCountsApi({})
    .then(response => {
      dispatch(syncCircleSpacesSuccess(response));
      setTimeout(() => {
        dispatch(syncCircleSpacesClear());
      }, 4000);
      return response;
    })
    .catch(e => {
      const errorMessage = e.message || 'Failed to start Circle spaces sync';
      dispatch(syncCircleSpacesError(errorMessage));
      setTimeout(() => {
        dispatch(syncCircleSpacesClear());
      }, 4000);
      throw e;
    });
};

export const loadData = (params, search) => (dispatch, getState) => {
  const queryParams = parse(search);
  const { page = 1, sort = 'asc', keyword = '' } = queryParams || {};

  return Promise.all([dispatch(fetchCurrentUser({}))])
    .then(async response => {
      const currentUser = getState().user.currentUser;
      if (currentUser?.attributes?.profile?.privateData?.isModAdmin) {
        dispatch(fetchSpaceList({
          per_page: TOTAL_GROUPS_PER_PAGE,
          page: page,
          sort,
          keyword,
          includeRulebookStatuses: false,
        }));
      }
      return response;
    })
    .catch(e => {
      throw e;
    });
};
